import React from 'react';
import UserLink from '../../../User/Link';
var MentionComponent = function (props) {
    if (!props || !props.componentData) {
        return null;
    }
    var mention = props.componentData.mention;
    if (!mention || !mention.name) {
        return null;
    }
    if (mention.type) {
        var user = {
            type: mention.type || 'standard',
            username: mention.name,
            userId: mention.userId || 0,
            useridUuid: mention.userUuid || '',
            usericon: mention.avatar,
            isNewDeviant: false,
        };
        return (React.createElement(UserLink, { user: user, withTooltip: true, className: "editor-mention-link" }));
    }
    // Fallback when we dont have enough info for user
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: "https://www.deviantart.com/" + mention.name
                .toLowerCase()
                .replace(/^@/, ''), title: mention.name }, "" + mention.name)));
};
MentionComponent.displayName = 'MentionComponent';
export default MentionComponent;
//# sourceMappingURL=mentionComponent.js.map